var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconLargeBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148711",
    "data-name": "Rectangle 148711",
    width: 32,
    height: 32,
    transform: "translate(-0.477 -0.477)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save",
    transform: "translate(0.477 0.477)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11939",
    "data-name": "Group 11939",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9107",
    "data-name": "Path 9107",
    d: "M44.66,28.521a20.11,20.11,0,0,1-1.024,4.986c-2.5-4.055-2.531-10.166-1.406-12.677.323-.709.627-.911.742-.92h.048a.444.444,0,0,1,.318.166c.83.816,1.595,3.808,1.31,8.437",
    transform: "translate(-29.844 -14.347)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9108",
    "data-name": "Path 9108",
    d: "M17.684,30.875a15.434,15.434,0,0,1-6.81-.56c.51-.65,1.039-1.361,1.546-2.106a36.125,36.125,0,0,0,2.5-4.282,4.649,4.649,0,0,0,2.362.1c3.785-.8,6.875-6.136,7.648-9.679.56-2.6,0-4.181-.6-5.041A3.759,3.759,0,0,0,21.9,7.678a4.136,4.136,0,0,0-2.891.6A1.466,1.466,0,1,0,20.5,10.8a1.238,1.238,0,0,1,.9-.23.8.8,0,0,1,.5.378,3.625,3.625,0,0,1,.168,2.8c-.656,2.969-3.208,6.965-5.4,7.413a1.6,1.6,0,0,1-.56.034,23.579,23.579,0,0,0,1.572-6.876C17.835,11.9,17.922,6,15.513,3.636a3.317,3.317,0,0,0-2.647-.994c-.765.059-2.193.479-3.174,2.616a15.575,15.575,0,0,0-.885,7.769,17.65,17.65,0,0,0,3.028,8.483,8.17,8.17,0,0,0,.625.765,71.043,71.043,0,0,1-4.387,6.839,15.523,15.523,0,1,1,9.611,1.756",
    transform: "translate(-0.002 0.018)",
    fill: "#0c0c0b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconLargeBlack);
export default __webpack_public_path__ + "static/media/logo-icon-large-black.003c3cf0.svg";
export { ForwardRef as ReactComponent };